import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import CommerceProduct from "@/components/commerceProduct/commerceProduct";
import { Getter, Mutation } from "vuex-class";
import CashbackTooltip from "@/components/cashbackTooltip/cashbackTooltip";
import { isAlreadyBought } from "@/plugins/products_helper";

@Component({
  components: {
    CommerceProduct,
    CashbackTooltip
  }
})
export default class ProductsCarousel extends Vue {
  @Prop({ default: () => [] }) products;
  @Prop({ default: null }) title;
  @Prop({ default: null }) route;
  @Prop({ default: true }) showMoreButton;
  @Prop({ default: null }) maximumProducts;

  @Getter getIsUnderMobile;
  @Getter getIsToken;

  @Mutation CURRENT_CATEGORY;

  scrollQuantity = 500;
  maxPosition = 0;
  currentPosition = 0;
  showLeftButton = true;
  showRightButton = true;
  maxProducts = 0;

  get isLeftButtonHidden() {
    if (this.currentPosition === 0) {
      return true;
    }
    return false;
  }

  get isRightButtonHidden() {
    if (this.currentPosition + 5 >= this.maxPosition) {
      return true;
    } else {
      return false;
    }
  }

  get getProducts() {
    let compare = (a, b) => {
      if(a.ordinal > b.ordinal) {
        return 1;
      } else if (a.ordinal < b.ordinal) {
        return -1;
      } else {
        return 0;
      }
    }
    let response = [];
    for (let i = 0; i < this.maxProducts && i < this.products.length; i++) {
      if (this.products[i]) {
        response.push(this.products[i]);
      }
    }
    response = response.sort((a,b) => a.ordinal - b.ordinal);
    return response;
  }

  mounted() {
    this.setMaxProducts();
    this.$nextTick(() => {
      this.setMaxPosition();
    });
    this.onScroll();
  }

  @Watch("getIsUnderMobile", { deep: true })
  setMaxProducts() {
    if (this.maximumProducts && this.maximumProducts > 0 ) {
      this.maxProducts = this.maximumProducts;
    } else if (!this.getIsUnderMobile) {
      this.maxProducts = 10;
    } else {
      this.maxProducts = 7;
    }
  }

  onScroll() {
    const productsContainer = document.getElementById(`productsContainer${this.title}`);
    this.currentPosition = productsContainer.scrollLeft;
  }

  _scroll(isLeft = false) {
    this.$nextTick(() => {
      if (isLeft) {
        this._moveLeft();
      } else {
        this._moveRight();
      }
    });
  }

  _moveLeft() {
    const productsContainer = document.getElementById(`productsContainer${this.title}`);
    productsContainer.scrollLeft -= this.scrollQuantity;
    this.currentPosition = productsContainer.scrollLeft;
  }

  _moveRight() {
    const productsContainer = document.getElementById(`productsContainer${this.title}`);
    productsContainer.scrollLeft += this.scrollQuantity;
    this.currentPosition = productsContainer.scrollLeft;
  }

  @Watch("currentPosition")
  setMaxPosition() {
    const productsContainer = document.getElementById(`productsContainer${this.title}`);
    if (productsContainer && productsContainer.scrollWidth && productsContainer.clientWidth) {
      let tmpMaxPosition = productsContainer.scrollWidth - productsContainer.clientWidth;
      if (tmpMaxPosition > this.maxPosition) {
        this.maxPosition = tmpMaxPosition;
      }
    }
  }

  _onRoute() {
    this.$emit('onRoute');
  }

  get getCashbackMessage() {
    let response = "";
    if (this.getIsToken) {
      response =
        "Aún no has probado los productos marcados con este ícono." +
        " <br /><b>¡Atrévete!</b>" +
        " y si no te gustan, <b>te devolvemos tu dinero en cashback.</b>";
    } else {
      response =
        "Te devolvemos el dinero de los productos que pruebes por primera vez y no te gusten." +
        " Al iniciar sesión sabrás cuales son.";
    }
    return response;
  }

  get showCashbackTooltip() {
    let response = false;
    if(!this.getIsToken) {
      response = true;
    } else {
      if(this.products && this.products.length) {
        for(let i=0; i < this.products.length && !response; i++) {
          const product = this.products[i];
          if(product && product.id && !isAlreadyBought(product.id)) {
            response = true;
          }
        }
      }
    }
    return response;
  }

  _truncate(value: string) {
    let response = value;
    if(this.getIsUnderMobile && value && value.length && value.length > 15) {
      response = value.substr(0, 15) + "...";
    }
    return response;
  }
}
